import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import styled from 'styled-components';
import Experience from './Experience';

// Wrapper to fix the canvas to the background
const CanvasWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1; 
  pointer-events: none;
  background-color: transparent;
`;

const Scene: React.FC = () => {
    return (
        <CanvasWrapper>
            <Canvas
                shadows
                dpr={[1, 2]} // Quality scaling
                gl={{
                    antialias: true,
                    alpha: true,
                }}
                camera={{ position: [0, 0, 5], fov: 45 }}
            >
                <color attach="background" args={['#ffffff']} />
                <fog attach="fog" args={['#ffffff', 5, 20]} />
                <Suspense fallback={null}>
                    <Experience />
                </Suspense>
            </Canvas>
        </CanvasWrapper>
    );
};

export default Scene;
